import { defineComponent, toRefs, ref, computed, provide, reactive, watch, nextTick, openBlock, createElementBlock, normalizeClass, renderSlot } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import { DIRECTIONS } from "../_utils/constant.js";
import { checkboxGroupKey } from "./context.js";
import _export_sfc from "../_virtual/plugin-vue_export-helper";
const _sfc_main = defineComponent({
  name: "CheckboxGroup",
  props: {
    modelValue: {
      type: Array,
      default: void 0
    },
    defaultValue: {
      type: Array,
      default: () => []
    },
    direction: {
      type: String,
      default: "horizontal",
      validator: (value) => DIRECTIONS.includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onChange: {
      type: [Function, Array]
    }
  },
  emits: [
    "update:modelValue",
    "change"
  ],
  setup(props, { emit }) {
    const { disabled } = toRefs(props);
    const prefixCls = getPrefixCls("checkbox-group");
    const _value = ref(props.defaultValue);
    const computedValue = computed(() => {
      var _a;
      return (_a = props.modelValue) != null ? _a : _value.value;
    });
    const handleChange = (value, e) => {
      _value.value = value;
      emit("update:modelValue", value);
      nextTick(() => {
        emit("change", value, e);
      });
    };
    provide(checkboxGroupKey, reactive({
      name: "ArcoCheckboxGroup",
      computedValue,
      disabled,
      handleChange
    }));
    const cls = computed(() => [
      prefixCls,
      `${prefixCls}-direction-${props.direction}`
    ]);
    watch(() => props.modelValue, (curValue) => {
      if (curValue) {
        _value.value = [...curValue];
      }
    });
    return {
      prefixCls,
      cls
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", {
    class: normalizeClass(_ctx.cls)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
var _CheckboxGroup = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { _CheckboxGroup as default };
